/* unplugin-vue-components disabled */import { render } from "./research.vue?vue&type=template&id=391f897b"
import script from "./research.vue?vue&type=script&lang=js"
export * from "./research.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ai-chat/ai-assistant/research/research.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "391f897b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('391f897b', __exports__)) {
    api.reload('391f897b', __exports__)
  }
  
  module.hot.accept("./research.vue?vue&type=template&id=391f897b", () => {
    api.rerender('391f897b', render)
  })

}


export default __exports__